//@flow
import {
	Divider,
	FormControl,
	FormHelperText,
	ListItem,
	ListItemIcon,
	ListItemText,
	TextField,
	Typography
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ErrorMessage } from "formik";
import React from 'react';
import { useTranslation } from "react-i18next";
import { normalizeGreek } from "../../../helpers/normalizeGreek";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import AddressLine from "./addressLine";
import { showNoValueIfDisabled } from "./catalog";
import FieldInfoPopupWrapper from "./fieldInfoPopupWrapper";

const CatalogDataEntry = ({
							  formik,
							  language,
							  inputVariant,
							  disabled,
							  catalogueProfileLength,
							  catalogueLanguage,
							  countriesEl,
							  countriesEn,
							  phoneCodesEl,
							  phoneCodesEn,
							  hideCatalogueAddress,
							  hideCatalogueProfile
						  }) => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	
	return (
		<>
			<ListItem sx={{ display: 'flex', gap: '0.5rem', p: 0 }}>
				<ListItemIcon sx={{
					minWidth: '2rem',
					width: "30px",
					height: "30px",
					borderRadius: "50%",
					overflow: "hidden",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					border: "2px solid  #dddddd00",
					marginBottom: '5px'
				}}>
					{language === 'el' ? <img
							src="https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Greece.svg"
							alt="Greece"
							style={{
								width: "100%",
								height: "100%",
								objectFit: "cover",
							}}
						/> :
						<img
							src="https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg"
							alt="Greece"
							style={{
								width: "100%",
								height: "100%",
								objectFit: "cover",
							}}
						/>
					}
				</ListItemIcon>
				<ListItemText>
					<Typography
						variant="bodyMedium"
						component={"div"}
						sx={{ color: 'text.main', fontWeight: 'bold', fontSize: '16px' }}
					>
						{language === 'el' ? t('DATA ENTRY FOR GREEK CATALOGUE') : t('DATA ENTRY FOR ENGLISH CATALOGUE')}
					</Typography>
				</ListItemText>
			</ListItem>
			<Divider sx={{ mb: '2rem', border: '1px solid', color: 'text.main' }}/>
			<Grid container spacing={1.5} sx={{ mb: 1.5, mt: 1 }}>
				<Grid size={12}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['brand.' + language] &&
							Boolean(formik.errors['brand.' + language])
						}
					>
						<FieldInfoPopupWrapper info={t('info_catalogue_company_name')}>
							<TextField
								label={t('catalogue_company_name')}
								disabled={disabled}
								fullWidth
								required
								variant={inputVariant}
								size={"small"}
								name={'brand.' + language}
								value={showNoValueIfDisabled(formik.values.brand[language], disabled)}
								onChange={(e) => {
									const oldValue = e.target.value
									formik.setFieldValue('brand.' + language, normalizeGreek(oldValue.toUpperCase()))
								}}
								onBlur={formik.handleBlur}
								maxLength={100}
							/>
						</FieldInfoPopupWrapper>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'brand.' + language}/>
						</FormHelperText>
					</FormControl>
				</Grid>
				{!hideCatalogueProfile && (
					<Grid size={12}>
						<FormControl
							variant="standard"
							color={'error'}
							fullWidth
							error={
								formik.touched['profile.' + language] &&
								Boolean(formik.errors['profile.' + language])
							}
						>
							<FieldInfoPopupWrapper info={t('info_catalogue_company_profile', {length: catalogueProfileLength})}>
								<TextField
									disabled={disabled}
									fullWidth
									variant={inputVariant}
									size={"small"}
									label={`${t('catalogue_company_profile')} ${!disabled ? formik.values.profile[language].length + '/' + catalogueProfileLength : ''}`}
									name={'profile.' + language}
									value={showNoValueIfDisabled(formik.values.profile[language], disabled)}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									multiline
									rows={3}
									maxLength={catalogueProfileLength ?? 800}
								/>
							</FieldInfoPopupWrapper>
							<FormHelperText sx={{ color: '#d32f2f' }}>
								<ErrorMessage name={'profile.' + language}/>
							</FormHelperText>
						</FormControl>
					</Grid>
				)}
				{!hideCatalogueAddress && (
					<AddressLine
						t={t}
						disabled={disabled}
						formik={formik}
						language={language}
						inputVariant={inputVariant}
						index={1}
						countriesEl={countriesEl}
						countriesEn={countriesEn}
						phoneCodesEl={phoneCodesEl}
						phoneCodesEn={phoneCodesEn}
						catalogueLanguage={catalogueLanguage}
					/>
				)}
				{!hideCatalogueAddress && (
					<AddressLine
						t={t}
						disabled={disabled}
						formik={formik}
						language={language}
						inputVariant={inputVariant}
						index={2}
						countriesEl={countriesEl}
						countriesEn={countriesEn}
						phoneCodesEl={phoneCodesEl}
						phoneCodesEn={phoneCodesEn}
						catalogueLanguage={catalogueLanguage}
					/>
				)}
			</Grid>
		</>
	)
}

export default CatalogDataEntry;